"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ButtonLink = _interopRequireDefault(require("../../ButtonLink"));

var _Close = _interopRequireDefault(require("../../icons/Close"));

var _useTranslate = _interopRequireDefault(require("../../hooks/useTranslate"));

var ModalCloseButton = function ModalCloseButton(_ref) {
  var onClick = _ref.onClick,
      dataTest = _ref.dataTest;
  var translate = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement(_ButtonLink.default, {
    onClick: onClick,
    size: "normal",
    iconLeft: /*#__PURE__*/_react.default.createElement(_Close.default, null),
    dataTest: dataTest,
    type: "secondary",
    title: translate("button_close")
  });
};

var _default = ModalCloseButton;
exports.default = _default;